import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_COMPANY,
  COLUMN_STUDIO,
  COLUMN_DEPARTMENT,
  COLUMN_TEAM,
  COLUMN_SUPER_TEAM,
  COLUMN_MANAGER,
  COLUMN_POSITION,
  COLUMN_TEST,
  COLUMN_LAST_LOGIN,
  COLUMN_REG_DATE,
} from 'scenes/Users/AdminUsers/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_COMPANY,
    COLUMN_STUDIO,
    COLUMN_DEPARTMENT,
    COLUMN_TEAM,
    COLUMN_SUPER_TEAM,
    COLUMN_MANAGER,
    COLUMN_POSITION,
    COLUMN_TEST,
    COLUMN_LAST_LOGIN,
    COLUMN_REG_DATE,
  ]),
  collapsed: array(string()).default([]),
});
